<div class="table-search">
  <div class="table-search__carousel">
    @if (showLeftArrow()) {
      <button
        mat-icon-button
        color="primary"
        class="table-search__arrow table-search__arrow--left"
        aria-label="Desplazar filtros a la izquierda"
        (click)="scroll('left')"
      >
        <mat-icon color="primary">chevron_left</mat-icon>
      </button>
    }

    <div class="table-search__filters-container" #filtersContainer>
      @for (filter of filters(); track filter.id) {
        @switch (filter.type) {
          @case ('text') {
            <mat-form-field appearance="outline" class="table-search__filter">
              <mat-label>{{ filter.label }}</mat-label>
              <input matInput [formControl]="getFilterControl(filter.id)" [placeholder]="filter.placeholder || ''" />
              @if (getFilterValue(filter.id)) {
                <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearFilter(filter.id)">
                  <mat-icon color="warn">clear</mat-icon>
                </button>
              }
            </mat-form-field>
          }
          @case ('date') {
            <mat-form-field appearance="outline" class="table-search__filter">
              <mat-label>{{ filter.label }}</mat-label>
              <input
                matInput
                [matDatepicker]="datePicker"
                [formControl]="getFilterControl(filter.id)"
                [placeholder]="filter.placeholder || ''"
                [matDatepickerFormat]="'dd/MM/yyyy'"
              />
              <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
              @if (getFilterValue(filter.id)) {
                <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearFilter(filter.id)">
                  <mat-icon color="warn">clear</mat-icon>
                </button>
              }
              <mat-datepicker #datePicker></mat-datepicker>
            </mat-form-field>
          }
          @case ('dateRange') {
            <mat-form-field appearance="outline" class="table-search__filter">
              <mat-label>{{ filter.label }}</mat-label>
              <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="filterForm">
                <input matStartDate [formControlName]="filter.id + '_start'" placeholder="Desde" [matDatepickerFormat]="'dd/MM/yyyy'" />
                <input matEndDate [formControlName]="filter.id + '_end'" placeholder="Hasta" [matDatepickerFormat]="'dd/MM/yyyy'" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
              @if (getFilterValue(filter.id + '_start') || getFilterValue(filter.id + '_end')) {
                <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearDateRange(filter.id)">
                  <mat-icon color="warn">clear</mat-icon>
                </button>
              }
              <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
          }
          @case ('multi-select') {
            <mat-form-field appearance="outline" class="table-search__filter">
              <mat-label>{{ filter.label }}</mat-label>
              <mat-select [formControl]="getFilterControl(filter.id)" [placeholder]="filter.placeholder || ''" multiple>
                @for (option of filter.options || []; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
              @if (hasMultiSelectValue(filter.id)) {
                <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearFilter(filter.id)">
                  <mat-icon color="warn">clear</mat-icon>
                </button>
              }
            </mat-form-field>
          }
          @case ('select') {
            <mat-form-field appearance="outline" class="table-search__filter">
              <mat-label>{{ filter.label }}</mat-label>
              <mat-select
                [formControl]="getFilterControl(filter.id)"
                [placeholder]="filter.placeholder || ''"
                (selectionChange)="filter.id === 'rangeField' ? handleRangeFieldSelection($event.value) : null"
              >
                @for (option of filter.options || []; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
              @if (getFilterValue(filter.id)) {
                <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearFilter(filter.id)">
                  <mat-icon color="warn">clear</mat-icon>
                </button>
              }
            </mat-form-field>
          }
          @case ('autocomplete') {
            <mat-form-field appearance="outline" class="table-search__filter">
              <mat-label>{{ filter.label }}</mat-label>
              <input
                type="text"
                matInput
                [formControl]="getFilterControl(filter.id)"
                [placeholder]="filter.placeholder || ''"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete #auto="matAutocomplete">
                @for (option of getFilteredOptions(filter.id)(); track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-autocomplete>
              @if (getFilterValue(filter.id)) {
                <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearFilter(filter.id)">
                  <mat-icon color="warn">clear</mat-icon>
                </button>
              }
            </mat-form-field>
          }
        }

        @if (filter.id === 'rangeMin' && getFilterValue('rangeField')) {
          <mat-form-field appearance="outline" class="table-search__filter">
            <mat-label>{{ filter.label }}</mat-label>
            <input
              matInput
              type="number"
              [formControl]="getFilterControl(filter.id)"
              [attr.min]="getSelectedRangeMin()"
              [attr.max]="getSelectedRangeMax()"
              [placeholder]="getSelectedRangeMin()?.toString() || ''"
            />
            @if (getFilterValue(filter.id) !== null && getFilterValue(filter.id) !== undefined) {
              <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearSingleRangeFilter('rangeMin')">
                <mat-icon color="warn">clear</mat-icon>
              </button>
            }
          </mat-form-field>
        }
        @if (filter.id === 'rangeMax' && getFilterValue('rangeField')) {
          <mat-form-field appearance="outline" class="table-search__filter">
            <mat-label>{{ filter.label }}</mat-label>
            <input
              matInput
              type="number"
              [formControl]="getFilterControl(filter.id)"
              [attr.min]="getSelectedRangeMin()"
              [attr.max]="getSelectedRangeMax()"
              [placeholder]="getSelectedRangeMax()?.toString() || ''"
            />
            @if (getFilterValue(filter.id) !== null && getFilterValue(filter.id) !== undefined) {
              <button mat-icon-button matSuffix matTooltip="Borrar" (click)="clearSingleRangeFilter('rangeMax')">
                <mat-icon color="warn">clear</mat-icon>
              </button>
            }
          </mat-form-field>
        }
      }
    </div>

    @if (showRightArrow()) {
      <button
        mat-icon-button
        color="primary"
        class="table-search__arrow table-search__arrow--right"
        aria-label="Desplazar filtros a la derecha"
        (click)="scroll('right')"
      >
        <mat-icon color="primary">chevron_right</mat-icon>
      </button>
    }
  </div>

  <div class="table-search__action-wrapper">
    @if (hasActiveFilters()) {
    <button mat-raised-button color="warn" class="table-search__clear" (click)="clearAllFilters()">
      <mat-icon class="table-search__clear-icon">clear</mat-icon>
      <span class="table-search__clear-text">Limpiar</span>
    </button>
    }
    <button mat-raised-button color="primary" class="table-search__submit" (click)="submitFilters()">
      <mat-icon class="table-search__submit-icon">search</mat-icon>
      <span class="table-search__submit-text">Buscar</span>
    </button>


  </div>
</div>
